import { createFileRoute } from '@tanstack/react-router';

import { ChornaPageContent } from '~/components/products/chorna/ChornaPageContent';

const ChornaPage = () => {
  return <ChornaPageContent />;
};

export const Route = createFileRoute('/$locale/products/chorna')({
  component: ChornaPage,
});
